import { replaceByObject } from '@/common/utils/strings/replace.utils';
import { LoginGuestRequest } from '@/core/domain/user/models/loginGuest-request.model';
import {
    LoginGuestData,
    LoginGuestResponse,
} from '@/core/domain/user/models/loginGuest-response.model';
import { LoginUserRequest } from '@/core/domain/user/models/loginUser-request.model';
import { LoginUserResponse } from '@/core/domain/user/models/loginUser-response.model';
import { UserResponse } from '@/core/domain/user/models/user-response.model';
import { UserRepository } from '@/core/domain/user/repositories/user.respository';
import { selectUser } from '@/core/user/store/reservation.selector';
import { saveUser } from '@/core/user/store/user.actions';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserImplRepository extends UserRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly store: Store,
    ) {
        super();
    }

    override loginUser(
        request: LoginUserRequest,
    ): Observable<LoginUserResponse> {
        return this.http
            .post<LoginUserResponse>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.loginGuest,
                ].join('/'),
                request,
            )
            .pipe(
                switchMap((response) => {
                    this.store.dispatch(saveUser({ value: response.data }));
                    return of(response);
                }),
            );
    }

    override getUser(): Observable<UserResponse> {
        return this.store.select(selectUser).pipe(
            switchMap((userCredentials: LoginGuestData) => {
                return this.http.get<UserResponse>(
                    replaceByObject(
                        [
                            environment.alamoApi.BASE_HOST,
                            environment.alamoApi.ENDPOINTS.user,
                        ].join('/'),
                        {
                            userId: userCredentials.idUser,
                        },
                    ),
                    {
                        headers: {
                            token: userCredentials.token as string,
                        },
                    },
                );
            }),
        );
    }

    override loginGuest(
        request: LoginGuestRequest,
    ): Observable<LoginGuestResponse> {
        return this.http
            .post<LoginGuestResponse>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.loginGuest,
                ].join('/'),
                request,
            )
            .pipe(
                switchMap((response) => {
                    this.store.dispatch(saveUser({ value: response.data }));
                    return of(response);
                }),
            );
    }
}
